
<header id="topnav">
  <app-topbar></app-topbar>
  <app-horizontal-nav></app-horizontal-nav>
</header>

<router-outlet></router-outlet>

<app-footer></app-footer>
<app-right-sidebar></app-right-sidebar>
